export const extraLinks = {
  // La Huayca fucked up segment
  'zdQ5-Oi9CEpbQ8QP63lYqQ': { pano: 'IOqhyf2a_hguInD8tzfOsQ', heading: 290, replace: 'Pu02XCSdt7dJhkOyfA4dWw' },
  'Pu02XCSdt7dJhkOyfA4dWw': { pano: 'IOqhyf2a_hguInD8tzfOsQ', heading: 290, replace: '-BfPPoju-AbAorvjsRLV4A' },
  '-BfPPoju-AbAorvjsRLV4A': { pano: 'IOqhyf2a_hguInD8tzfOsQ', heading: 290, replace: 'skFT8AcwQcauyQ-2PhqJww' },
  'skFT8AcwQcauyQ-2PhqJww': { pano: 'IOqhyf2a_hguInD8tzfOsQ', heading: 290, replace: 'CETD7kzhHqPmStGojEcT4A' },
  'CETD7kzhHqPmStGojEcT4A': { pano: 'IOqhyf2a_hguInD8tzfOsQ', heading: 290, replace: 'hbsro3eifVvZnUwSKzZpjg' },
  'hbsro3eifVvZnUwSKzZpjg': { pano: 'IOqhyf2a_hguInD8tzfOsQ', heading: 290, replace: 'BThjZHLzQgzuanydxtzG_w' },
  'BThjZHLzQgzuanydxtzG_w': { pano: 'IOqhyf2a_hguInD8tzfOsQ', heading: 290, replace: 'Uw3Yb-aYd3RIZ_b_xwLjgA' },
  'Uw3Yb-aYd3RIZ_b_xwLjgA': { pano: 'IOqhyf2a_hguInD8tzfOsQ', heading: 290, replace: 'te1nRkGCMUqA1207TK6twg' },
  // entrance to Humberstone
  'zdZR5GppjFdWUpw0VKgNBQ': { pano: 'o_eeWzITcvQAg6xVnzInEQ', heading: 4 },
  'o_eeWzITcvQAg6xVnzInEQ': { pano: 'zdZR5GppjFdWUpw0VKgNBQ', heading: 180 },

  // Humberstone world exit
  'o9mETUVAgxbqquXFtBWFLw': { pano: 'dds', heading: 98 },
  'GA_DDHTmQ-kZilBwIFbbyg': { pano: 'dds', heading: 90 },
  'Vh9UaTMMN5kNCnBeF3ma9Q': { pano: 'dds', heading: 116 },

  // quick way to get off Humberstone hill
  // 'cWWmNs9jrwol6u3E1fz5DA': { pano: 'FWKxqbqOhoOS5JOE899m0A', heading: 180 },
};
